import { useCallback } from 'react';
import { useCreateSupportFeedbackMutation } from '../api';
import type { SupportFeedbackType } from '../support-feedback-modal';

interface UseSupportFeedbackOptions {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

export function useSupportFeedback(options?: UseSupportFeedbackOptions) {
    const [createMutation, { isLoading: isSubmitting, error: mutationError }] = useCreateSupportFeedbackMutation();

    const submitFeedback = useCallback(
        async (message: string, type: SupportFeedbackType) => {
            try {
                const result = await createMutation({
                    message,
                    type,
                }).unwrap();

                options?.onSuccess?.();

                return result;
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Unknown error occurred');
                options?.onError?.(error);
                throw error;
            }
        },
        [createMutation, options]
    );

    return {
        submitFeedback,
        isSubmitting,
        error: mutationError,
    };
}
